<template>

  <div class="footer-menu">
    <h3 class="footer-menu__title">{{ t("menu") }}</h3>
    <ul class="menu">
      <li class="menu__item" v-for="item in items">
        <router-link :to="`${item.link ? item.link : '/'}`">{{ t(item.code) }}</router-link>
      </li>
    </ul>
  </div>

</template>

<script>
import View from "@/views/View.vue"

export default {
  name: "FooterMenu",
  props: {
    items: {
      default() {
        return null
      }
    }
  },
  extends: View
}
</script>

<style scoped lang="scss">

.footer-menu {

  &__title {
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 10px;
    padding-bottom: 10px;
    font-size: 1.375rem;
    color: #000;

    @media screen and (max-width: 767px) {
      padding-bottom: 0;
    }
  }
}

.menu {
  list-style: none;
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 767px) {
    flex-direction: row;
    column-gap: 20px;
    flex-wrap: wrap;
  }

  &__item {
    margin: 7px 0;
    padding: 2px 0;
    cursor: pointer;

    & > a {
      display: block;
      transition: all 0.25s ease 0s;
      color: rgb(100, 100, 100);

      &:hover {
        color: rgb(73, 78, 155);
      }
    }
  }
}

html.contrast {

  & .footer-menu {

    &__title {
      color: #fff;
    }
  }

  & .menu {

    &__item {

      & > a {
        color: #d2d2d2;

        &:hover {
          color: gold;
        }
      }
    }
  }
}

</style>